import type { Option, Branch } from './nodes'
import { getIngt, ingtPlan } from '@/apis/oem'

const ingts = getIngt().then((res: any) => res.data)
const cache: any = {}
export const getPlan = async (ingredientsId: string): Promise<any[]> => {
  // id 1 有印刷方案
  // id 3 只有材质 尺寸
  const list: any[] = [
    {
      name: 'style',
      label: '直行便的款式推荐方案',
      key: 'ingredientsStyleId',
      customKey: 'custom',
      custom: [
        { type: 'textarea', label: '详细说明', key: 'ingredientsStyleDesc' },
        { type: 'image', label: '参考图片', key: 'ingredientsStyleRefImg' }
      ]
    },
    {
      name: 'materials',
      label: '直行便的材质推荐方案',
      key: 'ingredientsMaterialsId',
      customKey: 'custom',
      custom: [
        {
          type: 'textarea',
          label: '详细说明',
          key: 'ingredientsMaterialsDesc'
        },
        { type: 'image', label: '参考图片', key: 'ingredientsMaterialsRefImg' }
      ]
    },
    {
      name: 'size',
      label: '直行便的尺寸推荐方案',
      key: 'ingredientsSizeId',
      customKey: 'custom',
      custom: [
        { type: 'textarea', label: '详细说明', key: 'ingredientsSizeDesc' },
        { type: 'image', label: '参考图片', key: 'ingredientsSizeRefImg' }
      ]
    }
  ]
  if (!cache[ingredientsId]) {
    cache[ingredientsId] = await Promise.all(
      list.map(async (v) => {
        const plan = await ingtPlan(v.name, ingredientsId).then(
          (res: any) => res.data
        )
        v.tabs = plan
          .map((p: any) => {
            return {
              value: p[v.key],
              label: p[v.name],
              labelJP: p[v.name + 'Jp'],
              tipOption: {
                img: p[v.name + 'Img'],
                title: '示例',
                text: p.remark,
                textJP: p.remarkJp
              }
            }
          })
          .concat({
            value: v.customKey,
            label: '其他'
          })
        v.type = 'radio'
        return v
      })
    )
  }
  console.log(cache[ingredientsId])
  return cache[ingredientsId]
}
export default {
  13: async (): Promise<Branch> => {
    const data = await ingts
    const options: Option[] = data.map((v: any) => {
      return {
        label: v.ingredients,
        labelJP: v.ingredientsJp,
        value: v.ingredientsId,
        next: '131'
      }
    })
    options.push({
      label: '其他',
      value: '',
      next: '131'
    })
    return {
      type: 'BranchOption',
      title: '请问你要做什么辅料？',
      key: 'ingredientsId',
      options
    }
  },
  131: async (prev: any, data: any): Promise<any> => {
    const { ingredientsId } = prev.data
    const inset = ingredientsId
      ? await getPlan(ingredientsId)
      : [
        {
          type: 'textarea',
          label: '请填写款式说明',
          key: 'ingredientsStyleDesc'
        },
        {
          type: 'textarea',
          label: '请填写材质详细说明',
          key: 'ingredientsMaterialsDesc'
        },
        {
          type: 'textarea',
          label: '请填写尺寸详细说明',
          key: 'ingredientsSizeDesc'
        }
      ]
    const items = [
      {
        type: 'input',
        options: {
          maxlength: '128'
        },
        label: '商品名',
        key: 'productName'
      },
      {
        type: 'image',
        label: '图片',
        key: 'productImg'
      },
      {
        type: 'input',
        label: '参考链接',
        key: 'productUrl',
        options: {
          maxlength: 200
        }
      },
      ...inset,
      {
        type: 'color-card',
        label: '颜色',
        key: 'colorCard'
      },
      {
        type: 'radio',
        label: '是否需要加logo',
        key: 'isAppendLogo',
        customKey: 'A',
        tabs: [
          {
            value: 'A',
            label: '需要',
            tooltip: '如果需要联动logo可以上传图片填写说明或联系专职经理'
          },
          { value: 'B', label: '不需要' }
        ],
        custom: [
          {
            type: 'print-logo',
            label: '印刷方案',
            key: 'ingredientsLogoPrintModeId'
          },
          { type: 'image', label: '图片', key: 'logoUrl' },
          { type: 'textarea', label: '详细说明', key: 'logoDetailDesc' }
        ]
      }
    ]
    return {
      type: 'InfoForm',
      title: '请输入您想要的详细信息',
      items,
      data: {
        colorCard: []
      },
      next: '1311'
    }
  },
  // 辅料Sku&下单需求
  1311: (prev: any, data: any): any => {
    return {
      type: 'InfoForm',
      title: '请输入您的订单信息',
      tooltip:
        '直行便的报价与希望起订量和价格是否匹配，是我们判定是否为您寻源成功的判断依据。请您客观的填写。如果您的希望和市场行情差异过大，我们会之后先联系您，提出修改建议，再开始为您寻源报价。',
      table: {
        label: '价格和起订量',
        name: 'ingredientsTable',
        tooltip: '以上为参考报价，具体报价需要以最终报价为准'
      },
      items: [
        {
          type: 'add-sku',
          label: '规格及起订量',
          key: 'searchSourceOrderSkuList'
        },
        {
          type: 'number',
          options: {
            precision: 2
          },
          unit: '元',
          label: '期望价格',
          key: 'customerExpectPrice'
        },
        {
          type: 'number',
          options: {
            stepStrictly: true
          },
          unit: '件',
          label: '期望最低起订量',
          key: 'customerExpectMinOrderQuantity'
        },
        {
          type: 'date',
          label: '期望交期时间',
          key: 'customerExpectDeliveryTime',
          options: {
            disabledDate: (date: Date) => date.getTime() < Date.now()
          }
        },
        {
          type: 'checkbox-group',
          label: '侧重点',
          key: 'customerFocus',
          list: [{ label: '价格' }, { label: '品质' }, { label: '交期' }]
        },
        {
          type: 'textarea',
          label: '其他补充',
          key: 'orderDemandSupplement'
        }
      ],
      data: {
        searchSourceOrderSkuList: []
      },
      next: 'A'
    }
  }
}
